// Flow types automatically removed

import { defineMessages, useIntl } from 'dibs-react-intl';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect.tsx';
import formStyles from '../styles/FormGeneral.scss';
const messages = defineMessages({
    placeholder: {
        id: 'abt.matchmaker.form.country_placeholder',
        defaultMessage: 'Country',
    },
});
export const Country = ({ countryOptions, errorMessage, onChange, value }) => {
    const intl = useIntl();
    return (
        <div className={formStyles.formWrapper}>
            <BasicSelect
                dataTn="matchmaker-input-country"
                errorMessage={errorMessage}
                placeholder={intl.formatMessage(messages.placeholder)}
                options={countryOptions}
                value={value}
                onChange={onChange}
            />
        </div>
    );
};
